import { AxiosError } from 'axios'

import { getDocument } from '../../api/document'
import {
  DocumentType,
  ProductDocuments,
  SyncProtectionDocumentsResponse,
} from '../../generated/resolvers'
import { GraphqlException } from '../util'

export const setProtectionProduct = async (data: SyncProtectionDocumentsResponse | undefined, error: AxiosError<any> | null) => {
  //Error messages from BE are horrid and mostly returns 500s so I came up with this generic user friendly error message
  //I'm down to change it if needed
  if (error && error.response) {
    const errorMessage =
      'Documents are either not ready for download or already downloaded. Please try again later if you cannot find them in the document section or contact support.'
    throw new GraphqlException(errorMessage)
  }

  const documents: ProductDocuments = {
    application_doc_id: undefined,
    key_facts_doc_id: undefined,
    illustration_doc_id: undefined,
    policy_letter_doc_id: undefined,
  }

  const documentIds = data?.uploads && data?.uploads[0]?.document_ids
  const protectionId = data?.uploads && data.uploads[0]?.product_id

  if (documentIds) {
    await Promise.all(
      documentIds.map(async (document_id) => {
        const res = await getDocument(document_id)
        const { document } = res
        if (document?.type === DocumentType.InsuranceApplication) {
          documents.application_doc_id = document_id
        } else if (document?.type === DocumentType.InsuranceKeyFacts) {
          documents.key_facts_doc_id = document_id
        } else if (document?.type === DocumentType.InsuranceIllustration) {
          documents.illustration_doc_id = document_id
        } else if (document?.type === DocumentType.PolicyLetter) {
          documents.policy_letter_doc_id = document_id
        }
      }),
    )
  }

  const protectionProduct = {
    protection_id: protectionId,
    details: {
      documents: documents,
    },
  }

  return protectionProduct
}